/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type Dataset } from '@coze-arch/bot-api/knowledge';

import { FilterKnowledgeType } from './types';

export const WEBSITE_FORMAT_TYPE = 4;
export const WEBSITE_CRAWL_JOB_QUERY_KEY = 'website_crawl_job_id';
export const WEBSITE_URL_QUERY_KEY = 'website_url';
export const WEBSITE_DEFAULT_ICON_URI = 'default_icon/website_kn_default_icon.png';

export enum WebsiteCrawlJobStatus {
  Pending = 0,
  Running = 1,
  Succeeded = 2,
  Failed = 3,
}

export const isWebsiteFormatType = (formatType?: number | null) =>
  Number(formatType) === WEBSITE_FORMAT_TYPE;

export const isWebsiteKnowledgeDataset = (dataset?: Pick<Dataset, 'format_type'> | null) =>
  isWebsiteFormatType(dataset?.format_type);

export const isTextLikeFormatType = (formatType?: number | null) =>
  formatType === undefined || formatType === null || Number(formatType) === 0 || isWebsiteFormatType(formatType);

export const getFormatTypeFromKnowledgeFilter = (
  filterType?: FilterKnowledgeType,
) => {
  switch (filterType) {
    case FilterKnowledgeType.TABLE:
      return 1;
    case FilterKnowledgeType.IMAGE:
      return 2;
    case FilterKnowledgeType.WEBSITE:
      return WEBSITE_FORMAT_TYPE;
    case FilterKnowledgeType.TEXT:
      return 0;
    default:
      return undefined;
  }
};

export const isWebsiteCrawlJobFinished = (status?: number | null) =>
  status === WebsiteCrawlJobStatus.Succeeded ||
  status === WebsiteCrawlJobStatus.Failed;
